export default "__VITE_ASSET__DIetvQfW__$_?height=200&width=300__"